const LOGIN_FAILURE = "LOGIN_FAILURE";
const LOGIN_SUCCESS = "LOGIN_SUCCESS";
const LOGOUT = "LOGOUT";

export {LOGIN_FAILURE, LOGIN_SUCCESS, LOGOUT };